import {
  IsBoolean,
  IsInt,
  IsObject,
  IsOptional,
  IsString,
  Length,
  Max,
  MaxLength,
  Min,
} from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { Type } from 'class-transformer'
import {
  MAX_ACTIVITY_TYPE_CODE_LENGTH,
  MAX_ACTIVITY_TYPE_LABEL_LENGTH,
  MAX_ACTIVITY_TYPE_DESCRIPTION_LENGTH,
} from '../../../constants/activity-type.constants'

export class UpdateActivityTypeRequestDto {
  @ApiPropertyOptional({ type: 'string', maxLength: MAX_ACTIVITY_TYPE_CODE_LENGTH })
  @IsOptional()
  @IsString()
  @Length(2, MAX_ACTIVITY_TYPE_CODE_LENGTH)
  code?: string

  @ApiPropertyOptional({ type: 'string', maxLength: MAX_ACTIVITY_TYPE_LABEL_LENGTH })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_ACTIVITY_TYPE_LABEL_LENGTH)
  label?: string

  @ApiPropertyOptional({ maxLength: MAX_ACTIVITY_TYPE_DESCRIPTION_LENGTH, type: 'string' })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_ACTIVITY_TYPE_DESCRIPTION_LENGTH)
  description?: string

  @ApiPropertyOptional({ type: Object })
  @IsOptional()
  @IsObject()
  jsonSchema?: Record<string, any>

  @ApiPropertyOptional({ type: Object })
  @IsOptional()
  @IsObject()
  defaultConfig?: Record<string, any>

  @ApiPropertyOptional({ type: Boolean })
  @IsOptional()
  @IsBoolean()
  supportsAutoGrading?: boolean

  @ApiPropertyOptional({ type: Boolean })
  @IsOptional()
  @IsBoolean()
  supportsRetries?: boolean

  @ApiPropertyOptional({ type: Number })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(999)
  maxAttempts?: number

  @ApiPropertyOptional({ type: 'string', maxLength: 64 })
  @IsOptional()
  @IsString()
  @MaxLength(64)
  icon?: string

  @ApiPropertyOptional({ type: 'string', maxLength: 7 })
  @IsOptional()
  @IsString()
  @MaxLength(7)
  color?: string

  @ApiPropertyOptional({ type: 'string', maxLength: 64 })
  @IsOptional()
  @IsString()
  @MaxLength(64)
  category?: string

  @ApiPropertyOptional({ type: Boolean })
  @IsOptional()
  @IsBoolean()
  isActive?: boolean

  @ApiPropertyOptional({ type: Boolean, description: 'Le type est-il un exercice ?' })
  @IsOptional()
  @IsBoolean()
  isExercice?: boolean
}
